/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

export enum ListEmailTemplatesOutputTypesItem {
  BOOKING_BOOKED_MENTOR = 'BOOKING_BOOKED_MENTOR',
  BOOKING_BOOKED_LEARNER = 'BOOKING_BOOKED_LEARNER',
  BOOKING_REMINDER_MENTOR = 'BOOKING_REMINDER_MENTOR',
  BOOKING_REMINDER_LEARNER = 'BOOKING_REMINDER_LEARNER',
  BOOKING_CANCELLED_MENTOR = 'BOOKING_CANCELLED_MENTOR',
  BOOKING_CANCELLED_LEARNER = 'BOOKING_CANCELLED_LEARNER',
  BOOKING_UPDATED_MENTOR = 'BOOKING_UPDATED_MENTOR',
  BOOKING_UPDATED_LEARNER = 'BOOKING_UPDATED_LEARNER',
  BOOKING_MEETING_LINK_MENTOR = 'BOOKING_MEETING_LINK_MENTOR',
  BOOKING_MEETING_LINK_LEARNER = 'BOOKING_MEETING_LINK_LEARNER',
  BOOKING_MEETING_LINK_MISSING_MENTOR = 'BOOKING_MEETING_LINK_MISSING_MENTOR',
  PROFILE_VALIDATED = 'PROFILE_VALIDATED',
  PROFILE_DECLINED = 'PROFILE_DECLINED',
  ACTIVITY_VALIDATED = 'ACTIVITY_VALIDATED',
  ACTIVITY_DECLINED = 'ACTIVITY_DECLINED',
  DISPUTE_OPENED = 'DISPUTE_OPENED',
  DISPUTE_ACCEPTED = 'DISPUTE_ACCEPTED',
  DISPUTE_REJECTED = 'DISPUTE_REJECTED',
  PROFESSIONAL_BLOCKED = 'PROFESSIONAL_BLOCKED',
  PROFESSIONAL_UNBLOCKED = 'PROFESSIONAL_UNBLOCKED',
  USER_BLOCKED = 'USER_BLOCKED',
  USER_UNBLOCKED = 'USER_UNBLOCKED',
  PAYOUT_COMPLETED = 'PAYOUT_COMPLETED',
  PAYOUT_FAILED = 'PAYOUT_FAILED',
  REFUND_PROCESSED = 'REFUND_PROCESSED',
  REFUND_FAILED = 'REFUND_FAILED',
  STRIPE_ONBOARDING_INCOMPLETE = 'STRIPE_ONBOARDING_INCOMPLETE',
  REVIEW_RECEIVED_MENTOR = 'REVIEW_RECEIVED_MENTOR',
  ADMIN_PROFESSIONAL_PENDING_REVIEW = 'ADMIN_PROFESSIONAL_PENDING_REVIEW',
  ADMIN_PROFESSIONAL_REVISION_PENDING = 'ADMIN_PROFESSIONAL_REVISION_PENDING',
  ADMIN_ACTIVITY_PENDING_REVIEW = 'ADMIN_ACTIVITY_PENDING_REVIEW',
  ADMIN_ACTIVITY_REVISION_PENDING = 'ADMIN_ACTIVITY_REVISION_PENDING',
  ADMIN_REFUND_FAILED = 'ADMIN_REFUND_FAILED',
  ADMIN_PAYOUT_FAILED = 'ADMIN_PAYOUT_FAILED'
}
